import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, apiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vf_admin_token", data.token);
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(apiError(err?.response?.data?.detail, "Invalid email or password"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-foreground px-5">
      <div className="w-full max-w-sm rounded-sm border border-white/10 bg-card p-8 shadow-xl">
        <div className="mb-6 text-center">
          <span className="font-heading text-xl font-extrabold tracking-tight text-foreground">
            VISA<span className="text-primary">FLIGHT</span>
          </span>
          <p className="mt-1 text-sm text-muted-foreground">Admin dashboard</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" data-testid="admin-email" className="rounded-sm" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" data-testid="admin-password" className="rounded-sm" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <Button type="submit" data-testid="admin-login-btn" disabled={loading} className="w-full rounded-sm bg-primary font-semibold text-primary-foreground hover:bg-[#003DB3]">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Lock className="mr-2 h-4 w-4" /> Sign in</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
